module.exports = __webpack_public_path__ + "static/img/11.30fedeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/snip3down/11.png
// module id = UYem
// module chunks = 35